import { IncidentModel } from './incident.model';
export class FinanceIncident extends IncidentModel {
}
